export * from './static/Select';
export * from './static/RoleSelect';
export * from './static/GradeSelect';
export * from './static/MissionTypeSelect';
export * from './static/MissionTypeUngenderedSelect';
// redux connected components
export { default as SMSelect } from './redux/SMSelect';
export { default as BaseSelect } from './redux/BaseSelect';
export { default as PTBaseSelect } from './redux/PTBaseSelect';
export { default as PlatoonSelect } from './PlatoonSelect';
export { default as LabelSelect } from './redux/LabelSelect';
export { default as ParshaSelect } from './redux/ParshaSelect';
export { default as SoldierSelect } from './redux/SoldierSelect';
export { default as SubjectSelect } from './redux/SubjectSelect';
export { default as RewardSubjectSelect } from './redux/RewardSubjectSelect';
export { default as AchievementTaskSelect } from './redux/AchievementTaskSelect';



// WEBPACK FOOTER //
// ./src/components/selects/index.js